var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu"},[_vm._v("\n  Select a Chart:\n  "),_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/subsea"}},[_vm._v("Subsea")])],1),_c('li',[_c('router-link',{attrs:{"to":"/equipment"}},[_vm._v("Equipment")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }